/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback, useRef } from 'react';

export const useTimeout = (
	delay: number,
): {
	schedule: (callback: () => void) => void;
	cancel: () => void;
} => {
	const timeoutId = useRef<NodeJS.Timeout>();

	const schedule = useCallback(
		(callback: () => void): void => {
			if (timeoutId.current) {
				clearTimeout(timeoutId.current);
			}

			timeoutId.current = setTimeout(callback, delay);
		},
		[delay],
	);

	const cancel = useCallback((): void => {
		clearTimeout(timeoutId.current);
	}, []);

	return { schedule, cancel };
};
